<template>
  <v-container fluid grid-list-xl class="pb-0" :z-index="1000">
    <v-toolbar flat class="transparent section-definition-toolbar" :dense="dense" :extended="extended">
      <v-avatar class="box-glow" :tile="tile">
        <v-icon dark v-html="icon" v-if="icon"></v-icon>
        <span v-else>{{ title | first2Char }}</span>
      </v-avatar>
      <v-toolbar-title class="primary--text">{{ title }}</v-toolbar-title>
      <!--<v-toolbar-title class="toobar-extension" slot="extension">-->
        <!--<v-breadcrumbs v-if="breadcrumbs" :items="breadcrumbs" class="pl-0">-->
          <!--<v-icon slot="divider">chevron_right</v-icon>-->
        <!--</v-breadcrumbs>-->
      <!--</v-toolbar-title>-->
      <v-spacer></v-spacer>


      <!--<v-btn-->
      <!--  icon-->
      <!--  v-if="refresh_fn !== null"-->
      <!--&gt;-->
      <!--  <v-icon color="primary" >refresh</v-icon>-->
      <!--</v-btn>-->


      <!--<v-btn icon>-->
        <!--<v-icon color="primary">more_vert</v-icon>-->
      <!--</v-btn>-->


      <!--<v-menu-->
      <!--  offset-y-->
      <!--  left-->
      <!--  :close-on-content-click="false"-->
      <!--  :nudge-width="5"-->
      <!--  v-if="menuItems.length>0"-->
      <!--&gt;-->
      <!--  <template v-slot:activator="{ on }">-->
      <!--    <v-btn-->
      <!--      icon-->
      <!--      v-on="on"-->
      <!--    >-->
      <!--      <v-icon color="primary">more_vert</v-icon>-->
      <!--    </v-btn>-->
      <!--  </template>-->

      <!--  <v-list>-->
      <!--    <template v-for="item in menuItems" >-->
      <!--      <v-list-tile :key="item.title">-->
      <!--        <v-switch-->
      <!--                v-model="item.value"-->
      <!--                :label="item.title"-->
      <!--        ></v-switch>-->
      <!--      </v-list-tile>-->

      <!--    </template>-->

      <!--    &lt;!&ndash;<v-list-tile>&ndash;&gt;-->

      <!--      &lt;!&ndash;<v-switch&ndash;&gt;-->
      <!--        &lt;!&ndash;v-model="items[0].value"&ndash;&gt;-->
      <!--        &lt;!&ndash;:label="items[0].title"&ndash;&gt;-->
      <!--      &lt;!&ndash;&gt;</v-switch>&ndash;&gt;-->
      <!--    &lt;!&ndash;</v-list-tile>&ndash;&gt;-->

      <!--  </v-list>-->
      <!--</v-menu>-->


       <slot></slot>



    </v-toolbar>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
   data: () => ({

      dense: true,
      extended: false,

      items: [
         { title: 'Click Me kshfsdsdfhasdf', value: true },
         { title: 'Click Me 2', value: true },
      ]
   }),
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String,
    tile: {
      type: Boolean,
      default: true
    },
    menuItems: {
       type: Array,
       default: ()=> []
    },
     refresh_fn: {
        type: Function,
        default: ()=> null
     }
  }
};
</script>

<style lang="stylus" scoped>
.toobar-extension {
  margin-left: 5px !important;
}

.breadcrumb-section {
  margin-left: -25px !important;
}

.action-btn {
  margin-left: 5px !important;
}
</style>
